(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[63],{

/***/ 76417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zG": function() { return /* reexport */ LinkableError; },
  "jM": function() { return /* reexport */ useLinkableCustomerHook; },
  "qM": function() { return /* reexport */ useTranslate; }
});

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(82786);
// EXTERNAL MODULE: ./context/index.ts + 4 modules
var context = __webpack_require__(37829);
;// CONCATENATED MODULE: ./hooks/useTranslate.ts



var useTranslate = function(translationKeys) {
    var brandedTranslations = (0,react.useContext)(context/* TranslationContext */.OB);
    if (!brandedTranslations) throw new Error("@lendi/lala-customer-app: No translations loaded.");
    var translationsToReturn = new Array(translationKeys.length);
    translationKeys.forEach(function(key, index) {
        var translation = brandedTranslations[key];
        if (typeof translation === "string") {
            translationsToReturn[index] = translation;
        } else {
            translationsToReturn[index] = (translation === null || translation === void 0 ? void 0 : translation.requireParse) ? (0,html_react_parser/* default */.ZP)(translation.text) : translation === null || translation === void 0 ? void 0 : translation.text;
        }
    });
    return translationsToReturn;
};

// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(44229);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(36798);
// EXTERNAL MODULE: ../../../packages/lala-react/dist/esm/index.js + 27 modules
var esm = __webpack_require__(71384);
// EXTERNAL MODULE: ./api/customer.ts
var customer = __webpack_require__(81878);
;// CONCATENATED MODULE: ./hooks/useLinkableCustomerHook.ts





var LinkableError;
(function(LinkableError) {
    LinkableError["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    LinkableError["SERVER_ERROR"] = "SERVER_ERROR";
})(LinkableError || (LinkableError = {}));
var useLinkableCustomerHook = function() {
    var session = (0,esm/* useSession */.kP)();
    var status = session.status;
    var ref = (0,react.useState)(""), mobileNumber = ref[0], setMobileNumber = ref[1];
    var ref1 = (0,react.useState)(undefined), apiError = ref1[0], setApiError = ref1[1];
    (0,react.useEffect)(function() {
        var callLinkedCustomerFn = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data, mobileNumber, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,customer/* getLinkedCustomerMobile */.LC)(session)
                            ];
                        case 1:
                            data = _state.sent().data;
                            mobileNumber = data.data.mobileNumber;
                            setMobileNumber(mobileNumber);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            if (err.message.indexOf("403") > -1) {
                                setApiError(LinkableError.PERMISSION_DENIED);
                            } else {
                                setApiError(LinkableError.SERVER_ERROR);
                            }
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function callLinkedCustomerFn() {
                return _ref.apply(this, arguments);
            };
        }();
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(status === esm/* Status.Authenticated */.qb.Authenticated)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            callLinkedCustomerFn()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        status
    ]);
    return {
        mobileNumber: mobileNumber,
        apiError: apiError
    };
};

;// CONCATENATED MODULE: ./hooks/index.ts




/***/ }),

/***/ 94022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PQ": function() { return /* binding */ StyledContainer; },
/* harmony export */   "fC": function() { return /* binding */ Root; },
/* harmony export */   "zc": function() { return /* binding */ GridWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62792);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84209);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90471);
/* harmony import */ var _lendi_ui_container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58905);
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23783);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  overflow: hidden;\n  min-height: 100vh;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  && input {\n    font-size: max(14px, 1rem);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var Root = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c0c9611-0"
})(_templateObject(), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_1__.bg)("shade.25"));
// @ts-ignore
var GridWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_lendi_ui_container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c0c9611-1"
})(_templateObject2(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.my)("sm"), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_4__/* .gte */ .eg)("desktop")(_templateObject1(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.my)("xxl")));
// @ts-ignore
var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_lendi_ui_container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c0c9611-2"
})(_templateObject4(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.mt)("xxxs"), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_4__/* .gte */ .eg)("tablet")(_templateObject3(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.mt)("sm")));


/***/ }),

/***/ 29580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bt": function() { return /* binding */ AuthForm; },
/* harmony export */   "DL": function() { return /* binding */ PromptHighlight; },
/* harmony export */   "En": function() { return /* binding */ BenefitsUnit; },
/* harmony export */   "GL": function() { return /* binding */ BeforeWrapper; },
/* harmony export */   "IC": function() { return /* binding */ ImgPlaceHolder; },
/* harmony export */   "LQ": function() { return /* binding */ EmailIcon; },
/* harmony export */   "NL": function() { return /* binding */ Prompt; },
/* harmony export */   "Om": function() { return /* binding */ NoBr; },
/* harmony export */   "PE": function() { return /* binding */ PromptLink; },
/* harmony export */   "Th": function() { return /* binding */ PromptPlaceHolder; },
/* harmony export */   "U2": function() { return /* binding */ PromptBrokerInfoBox; },
/* harmony export */   "WR": function() { return /* binding */ DivMBSM; },
/* harmony export */   "Z0": function() { return /* binding */ Separator; },
/* harmony export */   "_U": function() { return /* binding */ MainContentWrapper; },
/* harmony export */   "_t": function() { return /* binding */ LocationIcon; },
/* harmony export */   "aT": function() { return /* binding */ PageSubHeader; },
/* harmony export */   "dx": function() { return /* binding */ PromptHeader; },
/* harmony export */   "eX": function() { return /* binding */ Actions; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "jn": function() { return /* binding */ RFFFieldWrapper; },
/* harmony export */   "mr": function() { return /* binding */ PageHeader; },
/* harmony export */   "rR": function() { return /* binding */ PromptBrokerDetailsBox; },
/* harmony export */   "wC": function() { return /* binding */ PromptMessage; },
/* harmony export */   "zL": function() { return /* binding */ YesNoButton; },
/* harmony export */   "zv": function() { return /* binding */ WrapBody; }
/* harmony export */ });
/* unused harmony exports ContentUnit, ExpiredUnit, CardWrapper, DefaultLoginWrapper, LoginVariantWrapper, LoginVariantContainer, ExtraContainer, StyledRequestCode, Content, Heading, SubHeading, Mainpage, ContentWrapper, AlertWrapper, WordWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var _lendi_ui_alert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71400);
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23783);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62792);
/* harmony import */ var _lendi_ui_container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58905);
/* harmony import */ var _lendi_ui_depth__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12987);
/* harmony import */ var _lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63518);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84209);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56158);
/* harmony import */ var _lendi_ui_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27233);
/* harmony import */ var _lendi_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97049);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90471);
/* harmony import */ var _lendi_ui_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68722);
/* harmony import */ var _lendi_ui_icon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79007);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  height: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  position: absolute;\n  width: 250px;\n  right: 0;\n  top: calc(2.5 * var(--lendi-ui-size));\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 978px;\n  margin: 0 auto;\n  display: flex;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n    justify-content: space-evenly;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  display: flex;\n  justify-content: space-around;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.14;\n  letter-spacing: normal;\n  text-align: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  line-height: 1.38;\n  text-align: center;\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-top: calc(-4 * var(--lendi-ui-size));\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  position: relative;\n  margin-top: calc(-2 * var(--lendi-ui-size));\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  ",
        "\n  ",
        "\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 320px;\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  margin: auto;\n\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  border: none;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 0px;\n  padding: 16px\n  background: var(--background-page, #f8f8f8);\n  color: var(--text-main, #474747);\n  font-style: normal;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  max-width: 380px;\n  padding-bottom: 20px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 6px;\n  background: var(--background-container, #fff);\n  margin-bottom: 32px;\n  overflow: hidden;\n  ",
        ";\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: stretch;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 24px;\n  text-align: left;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: stretch;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 40px;\n  text-align: center;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: stretch;\n  font-weight: 400;\n  font-size: 20px;\n  text-align: center;\n  margin-top: 8px;\n  margin-bottom: 32px;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: stretch;\n  font-weight: 400;\n  font-size: 16px;\n  text-align: center;\n  background-color: #f2f2f0;\n  padding: 4px;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px;\n  padding-bottom: 24px;\n  display: flex;\n  justify-content: start;\n  width: 100%;\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: flex-start;\n  gap: 8px;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 80px;\n  width: 80px;\n  min-width: 80px;\n  border-radius: 50%;\n  margin-right: 12px;\n  background-repeat: no-repeat;\n  background-position: center center;\n  border: 1px solid rgb(242, 242, 240);\n  background-size: cover;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 500;\n  display: flex;\n  white-space: nowrap;\n  word-break: break-all;\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 2px;\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 2px;\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: wrap;\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 6px;\n  display: inline-block;\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: stretch;\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  width: 100%;\n  flex-direction: column;\n  padding: 0 16px 0 16px;\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  height: 48px;\n  padding: 0px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  > span {\n    font-size: 14px;\n    line-height: 14px;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n  }\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}












// @ts-ignore
var ContentUnit = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-0"
})(_templateObject(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1,
        tablet: 1 / 2
    }
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.px)({
    mobile: "sm",
    tablet: "md"
}));
var ExpiredUnit = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-1"
})(_templateObject1(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1,
        tablet: 1 / 2
    }
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.px)({
    mobile: "sm",
    tablet: "md"
}));
var BenefitsUnit = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Unit */ .ZP.Unit).withConfig({
    componentId: "sc-96129cb6-2"
})(_templateObject3(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("lg")(_templateObject2()));
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-3"
})(_templateObject4(), _lendi_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .container */ .n);
var CardWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-4"
})(_templateObject5(), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_8__/* .display */ .jf)({
    mobile: "none",
    desktop: "block"
}));
// Default Sign in
var DefaultLoginWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-5"
})(_templateObject6());
// For AB testing we could have variants, this is the wrapper for that.
var LoginVariantWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-6"
})(_templateObject8(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: 1
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.my)("md"), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("tablet")(_templateObject7(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.my)("lg")));
// Left side variant
var LoginVariantContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-7"
})(_templateObject9(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 0.9,
        tablet: 3 / 8,
        desktop: 6 / 16
    },
    offset: {
        mobile: 0,
        tablet: 0,
        desktop: 2 / 16
    }
}));
// Right side variant
var ExtraContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-8"
})(_templateObject10(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        tablet: 3.5 / 8,
        desktop: 7 / 16
    },
    offset: {
        tablet: 0,
        desktop: 1 / 16
    }
}), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_8__/* .display */ .jf)({
    mobile: "none",
    tablet: "inherit"
}));
var StyledRequestCode = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-9"
})(_templateObject11(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1
    }
}));
var Content = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-10"
})(_templateObject12(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1,
        tablet: 0.9,
        desktop: 0.6
    }
}));
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-11"
})(_templateObject13(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1,
        tablet: 0.9,
        desktop: 0.7
    }
}), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .heading */ .nP)({
    size: "md",
    color: "shade.800"
}));
var SubHeading = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-12"
})(_templateObject14(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .body */ .d1)({
    size: "md",
    color: "shade.700"
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.my)("lg"));
var Mainpage = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-13"
})(_templateObject16(), _lendi_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .container */ .n, (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("desktop")(_templateObject15()));
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-14"
})(_templateObject18(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .between */ .vX)("mobile", "tablet")(_templateObject17(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.mx)("xs")));
var BeforeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-96129cb6-15"
})(_templateObject19(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.ml)("sm"), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .body */ .d1)({
    size: "lg",
    color: "shade.500"
}));
var AlertWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-96129cb6-16"
})(_templateObject20(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.mb)("sm"));
var RFFFieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-17"
})(_templateObject21(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.mb)("sm"));
var WordWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-96129cb6-18"
})(_templateObject22());
var NoBr = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-96129cb6-19"
})(_templateObject23());
var AuthForm = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-96129cb6-20"
})(_templateObject25(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("tablet")(_templateObject24()));
var DivMBSM = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-21"
})(_templateObject26(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.mb)("sm"));
var Separator = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
    componentId: "sc-96129cb6-22"
})(_templateObject27(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.my)("lg"), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$)("shade.200"));
var MainContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-23"
})(_templateObject28());
var Prompt = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-24"
})(_templateObject29(), (0,_lendi_ui_depth__WEBPACK_IMPORTED_MODULE_11__/* .depth */ .Y)(1));
// @ts-ignore
var PromptHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Heading */ .X6).withConfig({
    componentId: "sc-96129cb6-25"
})(_templateObject30());
// @ts-ignore
var PageHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Heading */ .X6).withConfig({
    componentId: "sc-96129cb6-26"
})(_templateObject31());
var PageSubHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT).withConfig({
    componentId: "sc-96129cb6-27"
})(_templateObject32());
var PromptHighlight = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT).withConfig({
    componentId: "sc-96129cb6-28"
})(_templateObject33());
var PromptBrokerInfoBox = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-29"
})(_templateObject34());
var PromptBrokerDetailsBox = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-30"
})(_templateObject35());
var ImgPlaceHolder = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-31"
})(_templateObject36());
var PromptLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .rU).withConfig({
    componentId: "sc-96129cb6-32"
})(_templateObject37());
var LocationIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_icon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z).withConfig({
    componentId: "sc-96129cb6-33"
})(_templateObject38());
var EmailIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_icon__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z).withConfig({
    componentId: "sc-96129cb6-34"
})(_templateObject39());
var WrapBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT).withConfig({
    componentId: "sc-96129cb6-35"
})(_templateObject40());
var PromptPlaceHolder = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-36"
})(_templateObject41());
var PromptMessage = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT).withConfig({
    componentId: "sc-96129cb6-37"
})(_templateObject42());
var Actions = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96129cb6-38"
})(_templateObject43());
var YesNoButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx).withConfig({
    componentId: "sc-96129cb6-39"
})(_templateObject44());


/***/ }),

/***/ 88758:
/***/ (function() {

/* (ignored) */

/***/ })

}]);